import {
  Team as SharedTeam,
  TeamStatus as SharedTeamStatus,
  TEAM_STATUSES as SharedTeamStatuses,
} from "shared/dist/types/Team";

export type TeamStatus = SharedTeamStatus;
export const TEAM_STATUSES = SharedTeamStatuses;

export default interface Team extends SharedTeam {}